import { Grid } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { Icons } from "assets";
import moment from "moment";
import React from "react";
import styles from "./style.module.scss";

const statusConfig: Record<number, { label: string; color: string }> = {
  0: { label: "New", color: "#2196f3" },
  1: { label: "Pending", color: "#ff9800" },
  2: { label: "Approved", color: "#4caf50" },
  3: { label: "Rejected", color: "#f44336" },
  4: { label: "Expired", color: "#9e9e9e" },
};

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement<any, any> },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ViewDemoRequest({ open, handleClose, selectedItem }: any) {
  const status = statusConfig[selectedItem?.status];

  const fields = [
    { label: "First Name", value: selectedItem?.first_name },
    { label: "Last Name", value: selectedItem?.last_name },
    { label: "Role", value: selectedItem?.role },
    { label: "Email", value: selectedItem?.email },
    { label: "Phone", value: selectedItem?.phone },
    { label: "Address", value: selectedItem?.address },
    { label: "School Name", value: selectedItem?.school_name },
    {
      label: "Multi Campus",
      value: selectedItem?.is_multi_campus ? "Yes" : "No",
    },
    { label: "Students Count", value: selectedItem?.students_count },
    { label: "Teachers Count", value: selectedItem?.teachers_count },
    {
      label: "Submitted",
      value: selectedItem?.created_at
        ? moment(selectedItem.created_at).format("MMM DD, YYYY hh:mm A")
        : "—",
    },
  ];

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="view-demo-request-dialog"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: (theme) => theme.spacing(90),
              position: "relative",
              padding: "24px",
            },
          },
        }}
      >
        <div className={styles.crossIcon}>
          <Icons.CrossIcon onClick={() => handleClose()} />
        </div>
        <div className={styles.title}>
          {selectedItem?.first_name} {selectedItem?.last_name}
        </div>
        <div className={styles.subtitle}>{selectedItem?.school_name}</div>
        {status && (
          <span
            className={styles.statusChip}
            style={{ backgroundColor: status.color }}
          >
            {status.label}
          </span>
        )}
        <Grid container sx={{ marginTop: "20px" }}>
          {fields.map((item, i) => (
            <Grid key={i} xs={12} md={6} marginBottom={"10px"}>
              <div className={styles.headingContainer}>
                <span>{item.label}</span>
                <span>{item.value ?? "—"}</span>
              </div>
            </Grid>
          ))}
        </Grid>
        {selectedItem?.notes && (
          <div className={styles.notesBox}>
            <div className={styles.notesLabel}>Notes</div>
            <div>{selectedItem.notes}</div>
          </div>
        )}
      </Dialog>
    </React.Fragment>
  );
}
